import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext';
import type { ListDealBase, OAListDeal } from '@openx/types/deal';
import { QueryKeys } from '@openx/utils/api/queryKeys';
import { useQuery } from '@tanstack/react-query';
import { GetDealsListDocument } from '../../../graphql/query/deals/GetDealsList.generated';
import type { DealsQueryCriteria } from '../../../modules/deals/DealsList/types';
import { getGraphQLRequestFromClient } from '../../../modules/graphql/types';
import { buildDealsQueryString } from './buildDealsQueryString';

export const useDealsListFetch: DealProviderConfig['useDealsListFetch'] = <T extends ListDealBase = OAListDeal>(
  queryCrit: DealsQueryCriteria | undefined
) => {
  const queryString = buildDealsQueryString(queryCrit);

  const {
    data,
    isLoading: loading,
    error,
  } = useQuery({
    queryFn: ({ client }) => getGraphQLRequestFromClient(client)(GetDealsListDocument, { queryString }),
    queryKey: [QueryKeys.DEALS, 'list', queryString],
    staleTime: Infinity,
  });

  const deals = data?.deals?.objects?.map(dealRaw => ({
    ...dealRaw,
    deal_id: dealRaw.exchange_deal_id,
    deal_participants: dealRaw.exchange_deal?.deal_participants,
    synchronized_with: dealRaw.exchange_deal?.synchronized_with,
    uid: dealRaw.exchange_uid,
  }));

  return {
    dealsList: deals as unknown as T[],
    error: error ?? undefined,
    hasMore: data?.deals?.has_more,
    loading,
  };
};
